import useHttpMutation from 'data/firestore/useHttpMutation';
import { Agent } from 'data/firestore/agent/types';

export default (agentId?: string) => useHttpMutation<Partial<Omit<Agent, 'id' | 'createdAt' | 'updatedAt' | 'updatedBy'>>, Agent>({
    pathname: `/agents/${agentId}`,
    method: 'PATCH',
    server: process.env.REACT_APP_BASE_URL,
});
